import {
    Briefcase,
    Flame,
    HandHelping,
    Heart,
    HelpCircle,
    LoaderPinwheel,
    Quote,
    Shield,
    User,
} from "lucide-react";

export const PART_TYPES = [
    { label: "Protector", icon: Shield, value: ["Protector"] },
    {
        label: "Protector (Firefighter)",
        icon: Flame,
        value: ["Protector (Firefighter)"],
    },
    {
        label: "Protector (Manager)",
        icon: Briefcase,
        value: ["Protector (Manager)"],
    },
    {
        label: "Protector (Self-like)",
        icon: User,
        value: ["Protector (Self-like)"],
    },
    { label: "Exile", icon: Heart, value: ["Exile"] },
    {
        label: "Unattached Burden",
        icon: LoaderPinwheel,
        value: ["Unattached Burden (Confirmed)"],
        extendedOptions: true,
    },
    {
        label: "Guide",
        icon: HandHelping,
        value: ["guide", "Guide"],
        extendedOptions: true,
    },
    {
        label: "Other",
        icon: HelpCircle,
        value: ["other", "Other"],
    }, // SETTING type uses first value
];

export const getPartType = (partTypeText: string) =>
    PART_TYPES.find(
        (option) =>
            partTypeText &&
            option.value.some(
                (value) => value.toLowerCase() === partTypeText.toLowerCase(),
            ),
    );

export const ATTRIBUTE_LIST = [
    { key: "emotions", label: "Emotions" },
    {
        key: "beliefsIntentionsAndFears",
        alternateKeys: ["beliefsDesiresAndFears"],
        label: "Beliefs, Intentions, and Fears",
    },
    { key: "age", label: "Age" },
    { key: "role", label: "Role" },
    { key: "fear", label: "Fear" },
    { key: "behavioralExpression", label: "Behavioral Expression" },
    { key: "somaticExpression", label: "Somatic Expression" },
    { key: "visualExpression", label: "Visual Expression" },
    { key: "relationships", label: "Relationships" },
    { key: "burden", label: "Burden" },
    { key: "relationshipWithSelf", label: "Relationship with Self" },
];
